import React from "react";
import UnderDevelopmentPage from "../UnderDevelopment/UnderDevelopmentPage";

export default function LogMonitor() {
  return <div>
   Log Monitoring Page
  </div>;
}
